import { useEffect, useRef } from "react"

interface UseLineNumbersProps {
    enabled: boolean
    textAreaRef: React.RefObject<HTMLTextAreaElement | null>
    lineNumbersRef: React.RefObject<HTMLDivElement | null>
}

export const useLineNumbers = ({ enabled, textAreaRef, lineNumbersRef }: UseLineNumbersProps) => {
    useEffect(() => {
        if (!enabled) {
            return
        }

        if (textAreaRef.current && lineNumbersRef.current) {
            const syncScroll = () => {
                // Use requestAnimationFrame for better performance
                requestAnimationFrame(() => {
                    if (lineNumbersRef.current && textAreaRef.current) {
                        lineNumbersRef.current.scrollTop = textAreaRef.current.scrollTop
                    }
                })
            }

            textAreaRef.current.addEventListener('scroll', syncScroll)

            return () => {
                if (textAreaRef.current) {
                    textAreaRef.current.removeEventListener('scroll', syncScroll)
                }
            }
        }
    }, [enabled, textAreaRef, lineNumbersRef])
}
